import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { PlatformSidenavService } from '../../services/platform-sidenav.service';
import { PlatformViewHeaderService } from '../../services/platform-view-header.service';
import { PlatformApplyWithProfileModalComponent } from '../apply-with-profile-modal/platform-apply-with-profile-modal.component';
import { PlatformOnboardingModalComponent } from '../onboarding-modal/platform-onboarding-modal.component';
import { PlatformSidenavComponent } from '../sidenav/platform-sidenav.component';
import { PlatformTopnavComponent } from '../topnav/platform-topnav.component';

@Component({
  selector: 'app-platform-layout',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    PlatformSidenavComponent,
    PlatformTopnavComponent,
    RouterOutlet,
    PlatformApplyWithProfileModalComponent,
    PlatformOnboardingModalComponent,
  ],
  templateUrl: './platform-layout.component.html',
  styleUrl: './platform-layout.component.scss',
})
export class PlatformLayoutComponent {
  readonly sidenavService = inject(PlatformSidenavService);

  constructor() {
    // Eager init so browser tab title tracks platform route changes.
    inject(PlatformViewHeaderService);
  }
}
